__turbopack_context__.v({
  "container": "EmptyPlaceholder-module-scss-module__gRPQ_G__container",
});
